import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { Button, Heading } from '@chakra-ui/react';
import CustomInput from '../../Common/Input';
import CustomInputSelect from '../../Common/InputSelect';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
} from '@chakra-ui/react';

import { obtenerReservacion } from '../../../services/obtenerReservacion';
import ReservationContext from '../../../context/reservationContext';
import UserContext from '../../../context/userContext';
import { manejarReserva } from '../../../services/manejarReserva';
import { useTranslation } from 'react-i18next';
import { validacionCorreo } from '../../Admin/validaciones';

export default function ManejarReservaciones() {

  const { t } = useTranslation();

  const { user } = useContext(UserContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { reservacionId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const { reservation, setReservation } = useContext(ReservationContext);


  const [selectedArrivalDate, setSelectedArrivalDate] = useState('');
  const [selectedDepartureDate, setSelectedDepartureDate] = useState('');
  const [resType, setResType] = useState('');
  const [emailGuest, setEmailGuest] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  const [errorSelectedArrivalDate, setErrorSelectedArrivalDate] = useState(null);
  const [errorSelectedDepartureDate, setErrorSelectedDepartureDate] = useState(null);
  const [errorResType, setErrorResType] = useState(null);
  const [errorEmailGuest, setErrorEmailGuest] = useState(null);
  const [errorName, setErrorName] = useState(null);
  const [errorPhone, setErrorPhone] = useState(null);

  const [error, setError] = useState('');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    obtenerReservacion(user.id, reservacionId)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.reservacion);
        } else {
          setData({});
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const opcionesTipoReservacion = [
    { value: null, text: t("SELECT_RESERVATION") },
    { value: 'CORTESIA', text: t("COURTESY_RESERVATION") },
    { value: 'CUENTAPROPIA', text: t("OWN_NIGHTS_SALE") },
];

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'fechaLlegada') {
      setSelectedArrivalDate(value);
    }
    if (name === 'fechaSalida') {
      setSelectedDepartureDate(value);
    }
    const fecha = new Date(`${value}T00:00:00.000Z`);
    setReservation((prevData) => ({
      ...prevData,
      [name]: fecha,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'tipoReservacion') {
      setResType(value);
    }
    if (name === 'nombreQuienReserva') {
      setName(value);
    }
    if (name === 'telefono') {
      setPhone(value);
    }
    setReservation((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const submitChanges = async () => {
    const isValid = await checkInput.checkAll();
    if (!isValid) {
      return;
    }

    setLoading(true);

    try {
      const data = {
        reservacionId,
        llegada: new Date(selectedArrivalDate),
        salida: new Date(selectedDepartureDate),
        resType,
        name,
        phone,
        emailGuest,
      }
      
      const response = await manejarReserva(data)

      if(response.status !== 200) {
        console.log("ERROR")
        setError(response.data && response.data.error ? response.data.error : t("ERROR_OCCURRED"));
        onOpen()
        return
      }

      onOpen();
    } catch (e) {
      console.error(e);
      setError(e && e.response && e.response.data && e.response.data.error ? e.response.data.error : t("ERROR_OCCURRED"));
      onOpen();
    } finally {
      setLoading(false);
    }
  };

  const checkInput = {
    arrivalDate: async () => {
      if (!selectedArrivalDate) {
        setErrorSelectedArrivalDate(t("ARRIVAL_DATE_REQUIRED"));
        return false;
      }
      if (isNaN(new Date(selectedArrivalDate).getTime())) {
        setErrorSelectedArrivalDate(t("INVALID_ARRIVAL_DATE"));
        return false;
      }
      if (selectedDepartureDate && new Date(selectedArrivalDate) >= new Date(selectedDepartureDate)) {
        setErrorSelectedArrivalDate(t("ARRIVAL_DATE_MUST_BE_BEFORE_DEPARTURE_DATE"));
        return false;
      }
      setErrorSelectedArrivalDate(null);
      return true;
    },
    departureDate: async () => {
      if (!selectedDepartureDate) {
        setErrorSelectedDepartureDate(t("DEPARTURE_DATE_REQUIRED"));
        return false;
      }
      if (isNaN(new Date(selectedDepartureDate).getTime())) {
        setErrorSelectedDepartureDate(t("INVALID_DEPARTURE_DATE"));
        return false;
      }
      setErrorSelectedDepartureDate(null);
      return true;
    },
    resType: async () => {
      if (!resType) {
        setErrorResType(t("RESERVATION_TYPE_REQUIRED"));
        return false;
      }
      setErrorResType(null);
      return true;
    },
    name: async () => {
      if(!name || name.length === 0){
        setErrorName(t("NAME_REQUIRED"))
        return false
      }
      setErrorName(null)
      return true
    },
    phone: async () => {
      if(!phone || phone.length === 0){
        setErrorPhone(t("PHONE_REQUIRED"))
        return false
      }
      setErrorPhone(null)
      return true
    },
    email: async () => {
      if (!emailGuest || emailGuest.length === 0) {
        setErrorEmailGuest(t("EMAIL_REQUIRED"));
        return false;
      }
      
      if (!validacionCorreo.test(emailGuest)) {
        setErrorEmailGuest(t("INVALID_EMAIL"));
        return false;
      }
      setErrorEmailGuest(null);
      return true;
    },
    checkAll: async (skip=[]) =>{
      let result = true
      for(const key in checkInput){
        if(key === "checkAll" || skip.findIndex(itm => itm === key) !== -1){
          continue
        }
        const response = await checkInput[key]()
        if(result && !response){
          result = false
        }
      }
      return result
    }
  }

  const calculateMinDepartureDate = () => {
    if (selectedArrivalDate) {
      const arrivalDate = new Date(selectedArrivalDate);
      arrivalDate.setDate(arrivalDate.getDate() + 1); // Add one day to the arrival date
      return arrivalDate.toISOString().split('T')[0]; // Return in YYYY-MM-DD format
    }
    return data.fechaLlegada ? data.fechaLlegada.split('T')[0] : '';
  }

  const minDepartureDate = calculateMinDepartureDate();

  const calculateMaxArrivalDate = () => {
    if (data.fechaSalida) {
      const departureDate = new Date(data.fechaSalida);
      departureDate.setDate(departureDate.getDate() - 1); // Subtract one day from the departure date
      return departureDate.toISOString().split('T')[0]; // Return in YYYY-MM-DD format
    }
    return data.fechaSalida ? data.fechaSalida.split('T')[0] : '';
  }

  const maxArrivalDate = calculateMaxArrivalDate();

  return (
    <div className="px-5 py-2">
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
        <ModalHeader>
          {error ? t("ERROR") : t("CHANGES_SAVED")}
        </ModalHeader>
        <ModalBody>
          {error ? (
            <div>
              <div>{t("ERROR_OCCURRED_WITH_DETAILS")}{error}</div>
              <Button onClick={onClose} colorScheme="red" float={"right"} mb={2}>
                {t("CLOSE")}
              </Button>
            </div>
          ) : (
            <div className="py-3">
              <Button
                onClick={() => navigate('/reservar-ahora')}
                me="3"
                colorScheme="blue"
              >
                {t("GO_TO_FORM")}
              </Button>
              <Button
                onClick={() => navigate('/reservaciones')}
                colorScheme="orange"
              >
                {t("GO_TO_MY_RESERVATIONS")}
              </Button>
            </div>
          )}
        </ModalBody>
        </ModalContent>
      </Modal>
      <Heading my={2}>{t("MANAGE_RESERVATION")}</Heading>
      <p>
        {t("SELECT_DATES")}
      </p>
      <CustomInput
        label={t("ARRIVAL_DATE")}
        type="date"
        name="fechaLlegada"
        value={selectedArrivalDate}
        onChange={handleDateChange}
        min={data.fechaLlegada?.split('T')[0]}
        max={maxArrivalDate}
        onBlur={checkInput.arrivalDate}
        error={errorSelectedArrivalDate}
      />


      <CustomInput
        label={t("DEPARTURE_DATE")}
        type="date"
        name="fechaSalida"
        onChange={handleDateChange}
        value={selectedDepartureDate}
        min={minDepartureDate}
        max={data.fechaSalida?.split('T')[0]}
        onBlur={checkInput.departureDate}
        error={errorSelectedDepartureDate}
      />
      <br></br>
      <p className="p2-2">
        {t("RESERVATION_TYPE_NOTE")}
      </p>
      <CustomInputSelect
        label={t("RESERVATION_TYPE")}
        name="tipoReservacion"
        value={resType}
        options={opcionesTipoReservacion}
        onChange={handleChange}
        onBlur={checkInput.resType}
        error={errorResType}
      />
      <CustomInput
        label={t("GUEST_NAME")}
        name="nombreQuienReserva"
        type="text"
        value={name}
        onChange={handleChange}
        onBlur={checkInput.name}
        error={errorName}
      />

      <CustomInput
        label={t("GUEST_PHONE")}
        name="telefono"
        type="text"
        value={phone}
        onChange={handleChange}
        onBlur={checkInput.phone}
        error={errorPhone}
      />
      <CustomInput
        label={t("GUEST_EMAIL")}
        name="email"
        type="email"
        value={emailGuest}
        onChange={(e) => setEmailGuest(e.target.value)}
        onBlur={checkInput.email}
        error={errorEmailGuest}
      />
      <br></br>
      <Button
        colorScheme="facebook"
        onClick={() => submitChanges()}
        isLoading={loading}
        loadingText={t("SAVING_CHANGES")}
        disabled={loading}
      >
        {t("SAVE_CHANGES")}
      </Button>
    </div>
  );
}
